import React, {useEffect, useMemo, useState} from 'react';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {Box, Checkbox, Link, Modal, Switch, Typography, styled} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";
import TableContainer from "@mui/material/TableContainer";
import {
    findProfit,
    findTotal
} from "../../../Orders/OrdersChange/OrdersChangeTable/OrdersChangeTableBody/OrdersChangeTableBodyItem/OrderChangeTableBodyItem";

import { ReactComponent as Like } from '../../../../assets/svg/Like.svg'
import { ReactComponent as InProgress } from '../../../../assets/svg/inProgress.svg'
import { ReactComponent as Production } from '../../../../assets/svg/cap.svg'
import { ReactComponent as Delivery } from '../../../../assets/svg/scooterDelivery.svg'
import { ReactComponent as CONGEDOR } from '../../../../assets/svg/Congelador.svg'
import { ReactComponent as Plus } from '../../../../assets/svg/Plus.svg'
import ItemsProductionListItem from "./ItemsProductionListItem";
import {mainApi} from "../../../../store/services/mainApi";

const ItemsProductionList = ({editChange, handleSendDriverInformSendWhatsapp, setStatusesBuyer, statusesBuyer, setEditChange, drivers, statusBlock, setChangeStatus, statuses, mobileScreen, rowStyle, checkBoxStyle, rowStyleMap, switchStyle, statusBackground, selectedItems, allItemsArray, handleTopLevelSelectAlone, handleAllItemsSelect, setSwitchChecker, switchChecker, rows, openRows, toggleRowOpen, handleNestedSelect, userColumnsFieldsList}) => {

    const [statusModal, setStatusModal] = useState(false)

    const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
        padding: 0,
        '& .MuiSvgIcon-root': {
        width: 24,
        height: 24,
        borderRadius: '7px',
        border: '1px solid #d9d9d9',
        transition: 'all 0.2s',
        },
        '&.Mui-checked': {
        color: '#176318',
        '& .MuiSvgIcon-root': {
            borderColor: '#176318',
        }
        },
        '&:hover': {
        '& .MuiSvgIcon-root': {
            borderColor: '#176318',
            backgroundColor: 'rgba(23, 99, 24, 0.05)'
        }
        }
    }));
    const CheckedIcon = () => (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15124 14.737C6.7509 15.2616 5.96111 15.2614 5.561 14.7366L2.407 10.5995C2.00764 10.0756 1.21971 10.0743 0.818564 10.5968L0.465911 11.0561C0.190927 11.4143 0.190078 11.9123 0.46384 12.2714L5.56063 18.9569C5.96084 19.4818 6.75092 19.4818 7.15114 18.9569L19.5378 2.70918C19.8108 2.3511 19.8108 1.85472 19.5378 1.49663L19.1917 1.04265C18.7916 0.517833 18.0018 0.517653 17.6015 1.04229L7.15124 14.737Z" fill="#176318" />
        </svg>
    );
    const CheckIcon = () => (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15124 14.737C6.7509 15.2616 5.96111 15.2614 5.561 14.7366L2.407 10.5995C2.00764 10.0756 1.21971 10.0743 0.818564 10.5968L0.465911 11.0561C0.190927 11.4143 0.190078 11.9123 0.46384 12.2714L5.56063 18.9569C5.96084 19.4818 6.75092 19.4818 7.15114 18.9569L19.5378 2.70918C19.8108 2.3511 19.8108 1.85472 19.5378 1.49663L19.1917 1.04265C18.7916 0.517833 18.0018 0.517653 17.6015 1.04229L7.15124 14.737Z" fill="none" />
        </svg>
    );

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table" className='IProducAccordTable'>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{...rowStyle}}>
                            <Box className='LogisticOperation__filtersBar__container__item__grouping' sx={{ width: '24px', height: '24px',
        backgroundColor: '#fff' }}>
                                <CustomCheckbox
                                // Checked if all nested orders are selected
                                checked={selectedItems.length == allItemsArray.length}
                                onChange={(event) => handleAllItemsSelect()}
                                icon={<CheckIcon />}
                                checkedIcon={<CheckedIcon />}
                                />
                            </Box>
                        </TableCell>
                        {userColumnsFieldsList.includes('stat item') && <TableCell sx={{...rowStyle, padding: "0"}}  align="left">
                            Stat Item
                        </TableCell>}

                        {userColumnsFieldsList.includes('img') && <TableCell sx={rowStyle} align='center'>
                            Img
                        </TableCell>}
                        {userColumnsFieldsList.includes('item') && <TableCell sx={rowStyle}>Item</TableCell>}
                        {userColumnsFieldsList.includes('buyer') && <TableCell sx={rowStyle} align="center">Buyer</TableCell>}
                        {userColumnsFieldsList.includes('status order') && <TableCell sx={{...rowStyle, padding: "0"}}  align="left">
                            Status order
                        </TableCell>}

                        {userColumnsFieldsList.includes('order') && <TableCell sx={rowStyle} align="right">Order</TableCell>}
                        {userColumnsFieldsList.includes('unit') && <TableCell sx={rowStyle} align="right">Unit</TableCell>}
                        {userColumnsFieldsList.includes('quantity') && <TableCell sx={rowStyle} align="right">Quantity</TableCell>}
                        {userColumnsFieldsList.includes('total') && <TableCell sx={rowStyle} align="right">Total</TableCell>}
                        {userColumnsFieldsList.includes('delivery') && <TableCell sx={rowStyle} align="right">Delivery</TableCell>}
                        {userColumnsFieldsList.includes('time') && <TableCell sx={rowStyle} align="right">Time</TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {allItemsArray.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item) => (
                        <ItemsProductionListItem key={item._id + "|" + item.items._id} item={item} allItemsArray={allItemsArray}
                            handleSendDriverInformSendWhatsapp={handleSendDriverInformSendWhatsapp}
                            editChange={editChange} setEditChange={setEditChange}
                            statusBackground={statusBackground}
                            handleAllItemsSelect={handleAllItemsSelect}
                            switchChecker={switchChecker} setSwitchChecker={setSwitchChecker}
                            rows={rows} selectedItems={selectedItems}
                            handleTopLevelSelectAlone={handleTopLevelSelectAlone}
                            toggleRowOpen={toggleRowOpen} openRows={openRows}
                            handleNestedSelect={handleNestedSelect}
                            rowStyle={rowStyle}
                            rowStyleMap={rowStyleMap}
                            checkBoxStyle={checkBoxStyle}
                            switchStyle={switchStyle}
                            statuses={statuses}
                            mobileScreen={mobileScreen}
                            setChangeStatus={setChangeStatus}
                            statusBlock={statusBlock}
                            drivers={drivers}
                            setStatusesBuyer={setStatusesBuyer}
                            statusesBuyer={statusesBuyer}
                            userColumnsFieldsList={userColumnsFieldsList}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ItemsProductionList;